import React, { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import SectionCurationDetail from './SectionCurationDetail'
import { STORE_CURATION, STORE_CURATION_LOADING } from 'core/store/curation'
import SectionLayout from 'container/SectionLayout'

interface SectionCurationDetailProps {
  isVisible: boolean
}

const SectionCurationDetailGroup: React.FC<SectionCurationDetailProps> = ({ isVisible }) => {
  const curationList = useRecoilValue(STORE_CURATION)
  const isCurationLoading = useRecoilValue(STORE_CURATION_LOADING)

  /**
   * @name DOMElement
   **/
  const sectionCurationDetailEl = useMemo(() => {
    if (curationList) {
      return (
        <SectionLayout elementId="curationDetail" trigger={`${isCurationLoading}`}>
          {curationList.map((item) => (
            <SectionCurationDetail key={`${item.curationId}${item.regDt}`} curationItem={item} />
          ))}
        </SectionLayout>
      )
    }
  }, [curationList, isCurationLoading])

  if (!isVisible) {
    return <></>
  }

  return <>{sectionCurationDetailEl}</>
}

export default SectionCurationDetailGroup
